var PanelFooterItemView;

PanelFooterItemView = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-panel-footer-content',

	tagName: 'nav',

	id: 'kitbuilder-panel-footer-tools',

	possibleRotateModes: [ 'portrait', 'landscape' ],

	ui: {
		menuButtons: '.kitbuilder-panel-footer-tool',
		deviceModeIcon: '#kitbuilder-panel-footer-responsive > i',
		deviceModeButtons: '#kitbuilder-panel-footer-responsive .kitbuilder-panel-footer-sub-menu-item',
		buttonSave: '#kitbuilder-panel-footer-save',
		buttonSaveButton: '#kitbuilder-panel-footer-save .kitbuilder-button',
		buttonPublish: '#kitbuilder-panel-footer-publish',
		watchTutorial: '#kitbuilder-panel-footer-watch-tutorial',
		showTemplates: '#kitbuilder-panel-footer-templates-modal',
		saveTemplate: '#kitbuilder-panel-footer-save-template'
	},

	events: {
		'click @ui.deviceModeButtons': 'onClickResponsiveButtons',
		'click @ui.buttonSave': 'onClickButtonSave',
		'click @ui.buttonPublish': 'onClickButtonPublish',
		//'click @ui.watchTutorial': 'onClickWatchTutorial',
		'click @ui.showTemplates': 'onClickShowTemplates',
		'click @ui.saveTemplate': 'onClickSaveTemplate'
	},

	initialize: function() {
		this._initDialog();

		this.listenTo( kitbuilder.channels.editor, 'status:change', this.onEditorChanged )
			.listenTo( kitbuilder.channels.deviceMode, 'change', this.onDeviceModeChange );
	},

	_initDialog: function() {
		var dialog;

		this.getDialog = function() {
			if ( ! dialog ) {
				var $ = Backbone.$,
					$dialogMessage = $( '<div>', {
						'class': 'kitbuilder-dialog-message'
					} ),
					$messageIcon = $( '<i>', {
						'class': 'fa fa-check-circle'
					} ),
					$messageText = $( '<div>', {
						'class': 'kitbuilder-dialog-message-text'
					} ).text( kitbuilder.translate( 'saved' ) );

				$dialogMessage.append( $messageIcon, $messageText );

				dialog = kitbuilder.dialogsManager.createWidget( 'popup', {
					hide: {
						delay: 1500
					}
				} );

				dialog.setMessage( $dialogMessage );
			}

			return dialog;
		};
	},

	_publishBuilder: function() {
		var self = this;

		var options = {
			status: 'publish',
			onSuccess: function() {
				self.getDialog().show();

				self.ui.buttonSaveButton.removeClass( 'kitbuilder-button-state' );

				NProgress.done();
			}
		};

		self.ui.buttonSaveButton.addClass( 'kitbuilder-button-state' );

		NProgress.start();

		kitbuilder.saveEditor( options );
	},

	_saveBuilderDraft: function() {
		kitbuilder.saveEditor();
	},

	getDeviceModeButton: function( deviceMode ) {
		return this.ui.deviceModeButtons.filter( '[data-device-mode="' + deviceMode + '"]' );
	},

	onPanelClick: function( event ) {
		var $target = Backbone.$( event.target ),
			isClickInsideOfTool = $target.closest( '.kitbuilder-panel-footer-sub-menu-wrapper' ).length;

		if ( isClickInsideOfTool ) {
			return;
		}

		var $tool = $target.closest( '.kitbuilder-panel-footer-tool' ),
			isClosedTool = $tool.length && ! $tool.hasClass( 'kitbuilder-open' );

		this.ui.menuButtons.removeClass( 'kitbuilder-open' );

		if ( isClosedTool ) {
			$tool.addClass( 'kitbuilder-open' );
		}
	},

	onEditorChanged: function() {
		this.ui.buttonSave.toggleClass( 'kitbuilder-save-active', kitbuilder.isEditorChanged() );
	},

	onDeviceModeChange: function() {
		var previousDeviceMode = kitbuilder.channels.deviceMode.request( 'previousMode' ),
			currentDeviceMode = kitbuilder.channels.deviceMode.request( 'currentMode' );

		this.getDeviceModeButton( previousDeviceMode ).removeClass( 'active' );

		this.getDeviceModeButton( currentDeviceMode ).addClass( 'active' );

		// Change the footer icon
		this.ui.deviceModeIcon.removeClass( 'kb kb-device-' + previousDeviceMode ).addClass( 'kb kb-device-' + currentDeviceMode );
	},

	onClickButtonSave: function() {
		//this._saveBuilderDraft();
		this._publishBuilder();
	},

	onClickButtonPublish: function( event ) {
		// Prevent click on save button
		event.stopPropagation();

		this._publishBuilder();
	},

	onClickResponsiveButtons: function( event ) {
		var $clickedButton = this.$( event.currentTarget ),
			newDeviceMode = $clickedButton.data( 'device-mode' );

		kitbuilder.changeDeviceMode( newDeviceMode );
	},

	onClickWatchTutorial: function() {
		kitbuilder.introduction.startIntroduction();
	},

	onClickShowTemplates: function() {
		kitbuilder.templates.showTemplatesModal();
	},

	onClickSaveTemplate: function() {
		kitbuilder.templates.startModal( function() {
			kitbuilder.templates.getLayout().showSaveTemplateView();
		} );
	},

	onRender: function() {
		var self = this;

		_.defer( function() {
			kitbuilder.getPanelView().$el.on( 'click', _.bind( self.onPanelClick, self ) );
		} );
	}
} );

module.exports = PanelFooterItemView;
